import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  <div class="d-lightbox__header">
  {{#if @canNavigate}}
    <div aria-hidden="true" class="d-lightbox__multi-item-controls">
      <DButton
        {{on "click" @toggleCarousel passive=true capture=true}}
        @title="experimental_lightbox.buttons.carousel"
        @icon="images"
        @ariaHidden="true"
        aria-hidden="true"
        class="d-lightbox__carousel-button btn-flat"
      />
      <div class="d-lightbox__counters">
        <span class="d-lightbox__counter-current">
          {{~@counterIndex~}}
        </span>
        <span class="d-lightbox__counter-separator">
          <span>/</span>
        </span>
        <span class="d-lightbox__counter-total">
          {{~@totalItemCount~}}
        </span>
      </div>
    </div>
  {{/if}}
  <div class="d-lightbox__header-buttons">
    {{#if @canDownload}}
      <DButton
        {{on "click" @openInNewTab passive=true capture=true}}
        @title="experimental_lightbox.buttons.newtab"
        @icon="external-link-alt"
        @ariaHidden="true"
        aria-hidden="true"
        class="d-lightbox__new-tab-button btn-flat"
      />
    {{/if}}
    {{#if @canFullscreen}}
      <DButton
        {{on "click" @toggleFullScreen passive=true capture=true}}
        @title="experimental_lightbox.buttons.fullscreen"
        @icon="discourse-expand"
        @ariaHidden="true"
        aria-hidden="true"
        class="d-lightbox__full-screen-button btn-flat"
      />
    {{/if}}
    <DButton
      {{on "click" @close passive=true capture=true}}
      @title="experimental_lightbox.buttons.close"
      @icon="times"
      @ariaHidden="true"
      class="d-lightbox__close-button btn-flat"
    />
  </div>
</div>
*/
{
  "id": "znqQ0ZHG",
  "block": "[[[10,0],[14,0,\"d-lightbox__header\"],[12],[1,\"\\n\"],[41,[30,1],[[[1,\"    \"],[10,0],[14,\"aria-hidden\",\"true\"],[14,0,\"d-lightbox__multi-item-controls\"],[12],[1,\"\\n      \"],[8,[39,1],[[24,\"aria-hidden\",\"true\"],[24,0,\"d-lightbox__carousel-button btn-flat\"],[4,[38,2],[\"click\",[30,2]],[[\"passive\",\"capture\"],[true,true]]]],[[\"@title\",\"@icon\",\"@ariaHidden\"],[\"experimental_lightbox.buttons.carousel\",\"images\",\"true\"]],null],[1,\"\\n      \"],[10,0],[14,0,\"d-lightbox__counters\"],[12],[1,\"\\n        \"],[10,1],[14,0,\"d-lightbox__counter-current\"],[12],[1,[30,3]],[13],[1,\"\\n        \"],[10,1],[14,0,\"d-lightbox__counter-separator\"],[12],[1,\"\\n          \"],[10,1],[12],[1,\"/\"],[13],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,1],[14,0,\"d-lightbox__counter-total\"],[12],[1,[30,4]],[13],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],null],[1,\"  \"],[10,0],[14,0,\"d-lightbox__header-buttons\"],[12],[1,\"\\n\"],[41,[30,5],[[[1,\"      \"],[8,[39,1],[[24,\"aria-hidden\",\"true\"],[24,0,\"d-lightbox__new-tab-button btn-flat\"],[4,[38,2],[\"click\",[30,6]],[[\"passive\",\"capture\"],[true,true]]]],[[\"@title\",\"@icon\",\"@ariaHidden\"],[\"experimental_lightbox.buttons.newtab\",\"external-link-alt\",\"true\"]],null],[1,\"\\n\"]],[]],null],[41,[30,7],[[[1,\"      \"],[8,[39,1],[[24,\"aria-hidden\",\"true\"],[24,0,\"d-lightbox__full-screen-button btn-flat\"],[4,[38,2],[\"click\",[30,8]],[[\"passive\",\"capture\"],[true,true]]]],[[\"@title\",\"@icon\",\"@ariaHidden\"],[\"experimental_lightbox.buttons.fullscreen\",\"discourse-expand\",\"true\"]],null],[1,\"\\n\"]],[]],null],[1,\"    \"],[8,[39,1],[[24,0,\"d-lightbox__close-button btn-flat\"],[4,[38,2],[\"click\",[30,9]],[[\"passive\",\"capture\"],[true,true]]]],[[\"@title\",\"@icon\",\"@ariaHidden\"],[\"experimental_lightbox.buttons.close\",\"times\",\"true\"]],null],[1,\"\\n  \"],[13],[1,\"\\n\"],[13]],[\"@canNavigate\",\"@toggleCarousel\",\"@counterIndex\",\"@totalItemCount\",\"@canDownload\",\"@openInNewTab\",\"@canFullscreen\",\"@toggleFullScreen\",\"@close\"],false,[\"if\",\"d-button\",\"on\"]]",
  "moduleName": "discourse/components/d-lightbox/header.hbs",
  "isStrictMode": false
});